module.exports = __webpack_public_path__ + "img/youtube-icon.656e8895.svg";